// AIDialog.tsx
import React, { useState } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { Sparkles } from 'lucide-react'

interface AIDialogProps {
  onGetAISuggestions: (prompt: string) => Promise<string>
}

const AIDialog: React.FC<AIDialogProps> = ({ onGetAISuggestions }) => {
  const [askAIPrompt, setAskAIPrompt] = useState('')
  const [aiResponse, setAiResponse] = useState('')
  const [showAIDialog, setShowAIDialog] = useState(false)

  const handleAskAI = async () => {
    const response = await onGetAISuggestions(askAIPrompt)
    setAiResponse(response)
  }

  return (
    <Dialog open={showAIDialog} onOpenChange={setShowAIDialog}>
      <DialogTrigger asChild>
        <Button variant="outline" className='bg-black text-white hover:bg-gray-700 hover:text-white' size="sm">
          <Sparkles className="h-4 w-4 mr-1" />
          Ask AI
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Ask AI for Assistance</DialogTitle>
          <DialogDescription>
            Describe what you need help with, and our AI will provide suggestions.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <Input
            id="ai-prompt"
            placeholder="E.g., How can I improve this paragraph?"
            value={askAIPrompt}
            onChange={(e) => setAskAIPrompt(e.target.value)}
          />
          <Button onClick={handleAskAI}>Get AI Suggestions</Button>
          {aiResponse && (
            <div className="mt-4 p-4 bg-muted rounded-md">
              <h4 className="font-semibold mb-2">AI Suggestion:</h4>
              <p>{aiResponse}</p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default AIDialog
